import {
    Button,
    FormLabel,
    Grid,
    Paper,
    CircularProgress,
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody,
    Typography
} from '@material-ui/core';
import React, { useState, useCallback, useEffect, useContext, useMemo } from 'react';
import { SecondaryButton, SelectBox, TextBox } from '../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/styles';
import DialogComp from '../../../Core/Modal/dialogModal';
import { getCheckInTCards_GetByRegNumber } from '../../../Core/Service/checkInRole';
import _ from 'lodash';
import AppContext from '../../../App/AppContext';
import AddEditCheckIn from './addEditCheckIn';
import moment from 'moment';
const useStyles = makeStyles(() => ({
    button: {
        borderRadius: '8px',
        padding: '5px 16px',
        textTransform: 'none',
        color: '#fff',
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#155a9d'
        }
    },
    dropdownContainer: {
        position: 'absolute',
        zIndex: 1000,
        width: '100%',
        maxHeight: '200px',
        overflowY: 'auto',
        marginTop: '2px',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
    },
    dropdownItem: {
        textAlign: 'left',
        padding: '8px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    },
    highlightedItem: {
        backgroundColor: '#C24B3D',
        color: 'white',
        '&:hover': {
            backgroundColor: '#C24B3D'
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        padding: '0px 5px'
    },
    body: {
        fontSize: 14,
        padding: '0px 5px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        cursor: 'pointer',
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const CheckInDashboard = () => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const classes = useStyles();

    const [state, setState] = useState({
        regNumberToSearch: '',
        cashAccountTypeCategoryID: null,
        categories: [],
        vehicleList: [],
        loading: false,
        selectedVehicle: {}
    });

    const [isShow, setIsShow] = useState({ showJobPopup: false });
    const [showDropdown, setShowDropdown] = useState(false);

    const legendItems = useMemo(() => {
        if (!portalSettings) return [];
        return [
            {
                label: portalSettings?.portalSettingsCollectionDeliverText,
                background: portalSettings?.portalSettingsCollectionDeliverBgColor || 'black',
                color: portalSettings?.portalSettingsCollectionDeliverTextColor || 'white',
                st: 'cd'
            },
            {
                label: portalSettings?.portalSettingsCustomerWaitingText,
                background: portalSettings?.portalSettingsCustomerWaitingBgColor || 'black',
                color: portalSettings?.portalSettingsCustomerWaitingTextColor || 'white',
                st: 'waiting'
            },
            {
                label: portalSettings?.portalSettingsServiceText,
                background: portalSettings?.portalSettingsServiceBgColor || 'black',
                color: portalSettings?.portalSettingsServiceTextColor || 'white',
                st: 'service'
            },
            {
                label: portalSettings?.portalSettingsInspectionText,
                background: portalSettings?.portalSettingsInspectionBgColor || 'black',
                color: portalSettings?.portalSettingsInspectionTextColor || 'white',
                st: 'inspection'
            },
            {
                label: portalSettings?.portalSettingsMOTText,
                background: portalSettings?.portalSettingsMOTBgColor || 'black',
                color: portalSettings?.portalSettingsMOTTextColor || 'white',
                st: 'mot'
            },
            {
                label: portalSettings?.portalSettingsRepairText,
                background: portalSettings?.portalSettingsRepairBgColor || 'black',
                color: portalSettings?.portalSettingsRepairTextColor || 'white',
                st: 'repair'
            },
            {
                label: portalSettings?.portalSettingsNightShiftText,
                background: portalSettings?.portalSettingsNightShiftBgColor || 'black',
                color: portalSettings?.portalSettingsNightShiftTextColor || 'white',
                st: 'ns'
            },
            {
                label: portalSettings?.portalSettingsRecallJobText,
                background: portalSettings?.portalSettingsRecallJobBgColor || 'black',
                color: portalSettings?.portalSettingsRecallJobTextColor || 'white',
                st: 'recall'
            },
            {
                label: portalSettings?.portalSettingsTachoText,
                background: portalSettings?.portalSettingsTachoBgColor || 'black',
                color: portalSettings?.portalSettingsTachoTextColor || 'white',
                st: 'tacho'
            }
        ];
    }, [portalSettings]);

    // API Call with Debounce
    const fetchVehicles = async (regNumber) => {
        if (regNumber.length > 2) {
            setState((prev) => ({ ...prev, loading: true }));
            try {
                let res = await getCheckInTCards_GetByRegNumber(regNumber);
                setState((prev) => ({
                    ...prev,
                    vehicleList: res.data.tCards,
                    loading: false
                }));
                if (res.data.tCards.length > 0) {
                    setShowDropdown(true);
                } else {
                    showToast('Vehicles not found!');
                    setShowDropdown(false);
                }
            } catch (error) {
                console.error('Error fetching vehicles:', error);
                setState((prev) => ({ ...prev, loading: false }));
            }
        } else {
            setShowDropdown(false);
            setState((prev) => ({
                ...prev,
                vehicleList: [],
                loading: false
            }));
        }
    };

    const debouncedFetchVehicles = useCallback(_.debounce(fetchVehicles, 500), []);

    const fieldChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.trim().toUpperCase();
        setState((prev) => ({ ...prev, [name]: trimmedValue }));
        debouncedFetchVehicles(trimmedValue);
    };

    const handleVehicleSelect = (vehicle) => {
        setIsShow((prev) => ({ ...prev, showJobPopup: true }));
        setState((prev) => ({ ...prev, selectedVehicle: vehicle }));
    };

    const handleAddPopUp = (name) => {
        setIsShow((prev) => ({ ...prev, [name]: true }));
    };

    const closeWarningModal = (isCloseSuccess) => {
        setIsShow((prev) => ({ ...prev, showJobPopup: false }));
        if (isCloseSuccess) {
            setState((prev) => ({
                ...prev,
                vehicleList: [],
                loading: false,
                regNumberToSearch: '',
                selectedVehicle: {}
            }));
        }
    };

    const modalTitleRender = () => {
        return (
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>Job Details </Grid>
                <Grid item>Customer: {state.selectedVehicle.customer}</Grid>
                <Grid item>Reg No: {state.selectedVehicle.tCardsRegistrationNumber}</Grid>
            </Grid>
        );
    };

    return (
        <div style={{ padding: '20px' }}>
            {/* {state.isDashboard? */}
            <Grid container alignItems="center" spacing={2} justifyContent="center">
                <Grid item xs={12} md={12} lg={5} xl={4} style={{ position: 'relative' }}>
                    <FormLabel>Enter Registration Number</FormLabel>
                    <TextBox autoFocus name="regNumberToSearch" onChange={fieldChange} value={state.regNumberToSearch} />
                    {state.loading && <CircularProgress size={24} style={{ position: 'absolute', right: 15, top: 25 }} />}
                    {showDropdown && state.vehicleList.length > 0 && (
                        <Paper className={classes.dropdownContainer}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <StyledTableRow>
                                            {/* <StyledTableCell>Reg No</StyledTableCell>
                                            <StyledTableCell>Customer</StyledTableCell>
                                            <StyledTableCell></StyledTableCell> */}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.vehicleList.map((vehicle) => (
                                            <>
                                                <StyledTableRow
                                                    key={vehicle.loanVehicleID}
                                                    onClick={() => handleVehicleSelect(vehicle)}
                                                    // className={`${classes.dropdownItem} ${vehicle.headerRecordID ? classes.highlightedItem : ''}`}
                                                >
                                                    {/* <StyledTableCell>{vehicle.tCardsRegistrationNumber}</StyledTableCell>
                                                    <StyledTableCell>{vehicle.customer}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <SecondaryButton style={{ padding: '0px 8px' }}>CheckIn</SecondaryButton>
                                                    </StyledTableCell> */}
                                                    <Grid container alignItems="center" justifyContent="space-between" style={{ padding: '5px 10px' }}>
                                                        <Grid item xs={12}>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <Grid container spacing={1}>
                                                                        <Grid item>
                                                                            <Typography style={{ fontSize: 13, fontWeight: 600, color: vehicle.tcolor }}>
                                                                                Reg -{' '}
                                                                                {vehicle.tCardsRegistrationNumber ? vehicle.tCardsRegistrationNumber : 'N/A'}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <Typography style={{ fontSize: 13, fontWeight: 600, color: vehicle.tcolor }}>
                                                                                Booked - {vehicle.bd ? moment(vehicle.bd).format('DD/MM/YY') : 'N/A'}
                                                                            </Typography>
                                                                        </Grid>
                                                                        {/* <Grid item>
                                                                            <Typography style={{ fontSize: 13, fontWeight: 600, color: vehicle.tcolor }}>
                                                                                {vehicle.status ? `Status - ${vehicle.status}` : 'N/A'}
                                                                            </Typography>
                                                                        </Grid> */}
                                                                        <Grid item>
                                                                            <Typography style={{ fontSize: 13, fontWeight: 600, color: vehicle.tcolor }}>
                                                                                {vehicle.customer ? `Customer - ${vehicle.customer}` : 'N/A'}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <div
                                                                        style={{
                                                                            // display: 'grid',
                                                                            // rowGap: 1,
                                                                            // gridTemplateColumns: 'repeat(9, 1fr)',
                                                                            // justifyContent: 'flex-end'
                                                                            display: 'flex'
                                                                        }}
                                                                    >
                                                                        {legendItems
                                                                            .filter((m) => vehicle[m.st])
                                                                            .map((m) => (
                                                                                <div key={m.st} style={{ margin: '0px 2px', textAlign: 'center' }}>
                                                                                    <Typography
                                                                                        style={{
                                                                                            fontSize: 10,
                                                                                            fontWeight: 600,
                                                                                            background: m.background,
                                                                                            color: m.color,
                                                                                            padding: 2,
                                                                                            width: 40
                                                                                        }}
                                                                                    >
                                                                                        {m.label}
                                                                                    </Typography>
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} style={{ color: vehicle.tcolor, textAlign: 'left' }}>
                                                            {vehicle.notes}
                                                        </Grid>
                                                    </Grid>
                                                </StyledTableRow>
                                                {/* <StyledTableRow key={vehicle.loanVehicleID} colSpan={3}> */}

                                                {/* </StyledTableRow> */}
                                            </>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {/* {state.vehicleList.map((vehicle) => (
                                                      <div
                                                          key={vehicle.loanVehicleID}
                                                          onClick={() => handleVehicleSelect(vehicle)}
                                                          className={`${classes.dropdownItem} ${vehicle.headerRecordID ? classes.highlightedItem : ''}`}
                                                      >
                                                          {vehicle.tCardsRegistrationNumber}
                                                      </div>
                                                  ))} */}
                        </Paper>
                    )}
                </Grid>
                {/* <Grid item>
                    <Button variant="contained" className={classes.button} onClick={() => handleAddPopUp('showJobPopup')}>
                        Show Job
                    </Button>
                </Grid> */}
            </Grid>
            {/* :
           < AddEditCheckIn/>
            } */}
            {isShow.showJobPopup && (
                <DialogComp title={modalTitleRender()} maxWidth="xl" onClose={() => closeWarningModal(false)} fullWidth overflow="auto" fullScreen>
                    <AddEditCheckIn selectedVehicle={state.selectedVehicle} onClose={closeWarningModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default CheckInDashboard;
